import Array_Sum from './Array_Sum';

const Array_Average = (data) => {
  return Array_Sum(data) / data.length;
}

export default Array_Average;
